import script from "./WorkflowIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowIndicator.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowIndicator.vue?vue&type=style&index=0&id=4dc5ea41&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc5ea41"]])

export default __exports__